import React from 'react';
import {
  Col, Divider, Flex, Typography,
} from 'antd';
import { useTranslation } from 'react-i18next';
import OpinionsList from './OpinionsList';

const { Title } = Typography;

interface OpinionsProps {
  mentions?: {
    id: string;
    url: string;
    summary: string;
    headline: string | null;
  }[];
}

const Opinions = function ({ mentions = [] }: OpinionsProps) {
  const { t } = useTranslation();

  return !!mentions?.length && (
    <Flex wrap justify="center" gap="middle">
      <Divider />
      <Col span={24}>
        <Title level={4}>{t('chat:::communityGuuruOpinions')}</Title>
      </Col>
      <Col span={24}>
        <OpinionsList mentions={mentions} />
      </Col>
    </Flex>
  );
};

export default Opinions;
